import { fetchLineElevationProfile } from '../common/lineElevationSampling';
export { fetchLineElevationProfile as fetchSegmentElevationProfile };
export const combinedElevationProfiles = (segments) => {
    const validProfiles = segments
        .map(s => s.elevationProfile)
        .filter((p) => p !== null && p !== undefined);
    if (validProfiles.length === 0)
        return null;
    let cumulativeDistance = 0;
    let cumulativeDistance3d = 0;
    const combinedSamples = [];
    for (let i = 0; i < validProfiles.length; i++) {
        const profile = validProfiles[i];
        for (let j = 0; j < profile.samples.length; j++) {
            const sample = profile.samples[j];
            if (i > 0 && j === 0)
                continue;
            combinedSamples.push({
                distanceMeters: cumulativeDistance + sample.distanceMeters,
                elevationMeters: sample.elevationMeters,
                valid: sample.valid,
                distance3dMeters: cumulativeDistance3d + sample.distance3dMeters,
                layerValues: sample.layerValues
            });
        }
        cumulativeDistance += profile.totalDistanceMeters;
        cumulativeDistance3d += profile.totalDistance3dMeters;
    }
    // Combine per-layer stats: take the widest [min, max] across segments so the
    // chart's continuous colour scale (e.g. TWI Blues) covers every value on the
    // path. In practice all segments in one project share the same raster, so the
    // ranges are identical — defensive merge handles edge cases.
    const combinedLayerStats = {};
    for (const profile of validProfiles) {
        for (const [layer, stats] of Object.entries(profile.layerStats || {})) {
            const cur = combinedLayerStats[layer];
            if (!cur) {
                combinedLayerStats[layer] = { min: stats.min, max: stats.max };
            }
            else {
                combinedLayerStats[layer] = {
                    min: Math.min(cur.min, stats.min),
                    max: Math.max(cur.max, stats.max),
                };
            }
        }
    }
    return {
        samples: combinedSamples,
        totalDistanceMeters: cumulativeDistance,
        totalDistance3dMeters: cumulativeDistance3d,
        hemisphere: validProfiles[0].hemisphere,
        layerStats: combinedLayerStats,
    };
};
